import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const eventTicketKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'tickets'] as const;
  return createQueryKey({
    all: [...keys, 'tickets'] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...key, itemId] as const,
        detail: [...key, itemId, 'detail'] as const,
      }),
    export: [...key, 'export'] as const,
  });
};

const seasonTicketKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'season_passes'] as const;
  return createQueryKey({
    all: [...key] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...key, itemId] as const,
        detail: [...key, itemId, 'detail'] as const,
      }),
    export: [...key, 'export'] as const,
  });
};

export { eventTicketKeys, seasonTicketKeys };
